import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=c00e8ae0"
import script from "./AlertBox.vue?vue&type=script&lang=ts"
export * from "./AlertBox.vue?vue&type=script&lang=ts"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=c00e8ae0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports